
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			andUrl: '',
			logoSrc: ''
		}
	},
	computed: {
		...mapGetters({ config: 'config' })
	},
	methods: {
		// 创建二维码
		crateQrcode(qrCodeUrl) {
			const pzfrom = this.$cookies.get('pzfrom')
			const bdVid = this.$cookies.get('bdVid')
			const qhClickId = this.$cookies.get('qhClickId')
			const markId = this.$cookies.get('markId')
			this.logoSrc = `${qrCodeUrl}?${pzfrom ? `pzfrom=${pzfrom}` : ''}${bdVid ? `&bd_vid=${bdVid}` : ''}${qhClickId ? `&qhclickid=${qhClickId}` : ''}${markId ? `&mark_id=${markId}` : ''}`
		},
		/**
		 * app下载页面
		 * @param type
		 */
		getAppUrl(type) {
			const appUrl = this.$store.getters.config[this.$enum.CONFIG.config_8]
			if (!appUrl) {
				this.$store.dispatch('AppPublicConfig').then(res => {
					this.andUrl = res[this.$enum.CONFIG.config_8]
					if (this.andUrl) {
						this.$nextTick(() => {
							this.crateQrcode(res[this.$enum.CONFIG.config_8])
						})
					}
				})
				return
			}
			this.andUrl = appUrl
			this.$nextTick(() => {
				this.crateQrcode(appUrl)
			})
		}
	},
	mounted() {
		this.getAppUrl()
	}
}
